/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import reportsConfig from '../configs/reports-config';
import InlineQuery from '../../components/InlineQuery';

import Iframe from '../../components/Iframe';
import PageHeader from '../../components/PageHeader';
import { TabbedFilters, FilterTypes } from '../../components/Filters';
import Table from '../../components/Table';
import TitleBanner from '../../components/TitleBanner';
import { extractFilterValues } from '../../utils/filters';
import { columns, defaultSorts } from './table-config';

const BingeReport = ({
  filters,
  queries,
  queryActions: { runFormattedInlineQueriesForPage },
  filtersActions: { getFiltersForPage },
  blocked
}) => {
  const didMountRef = useRef(false);
  const [selectedFilters, setSelectedFilters] = useState({});

  const updateQueries = () => {
    runFormattedInlineQueriesForPage(
      reportsConfig.BINGE_REPORT_FILTERS,
      filters.fields
    );
  };

  useEffect(() => {
    if (blocked) {
      return;
    }

    const values = extractFilterValues(filters.fields);
    const hasNewValues = !isEqual(values, selectedFilters);
    if (didMountRef.current && hasNewValues && filters.groupings.length) {
      setSelectedFilters(values);
      updateQueries();
    }
  }, [blocked, filters.fields]);

  useEffect(() => {
    getFiltersForPage(reportsConfig.BINGE_REPORT_PAGE_ID);
    didMountRef.current = true;
    document.title = 'Rankings | Binge | CVM Insights';
  }, []);

  return (
    <>
      <TitleBanner>
        <PageHeader
          title="Binge"
          tooltip="Ranks shows based on overall share of binges for the selected time period."
        />
      </TitleBanner>

      {blocked && (
        <Iframe
          blocked
          blockedMessage="Contact your Client Success Representative to learn more about this report"
          url=""
          height="100%"
        />
      )}

      {!blocked && (
        <>
          <TabbedFilters />
          <section>
            <InlineQuery useChildForLoading query={queries.bingeReport}>
              {query => (
                <Table
                  data={queries.bingeReport.data}
                  headerFormatter={columns}
                  defaultSorts={defaultSorts}
                  view="bingeReport"
                  filters={filters.fields}
                  queryMeta={
                    reportsConfig.BINGE_REPORT_FILTERS.queries.bingeReport
                  }
                />
              )}
            </InlineQuery>
          </section>
        </>
      )}
    </>
  );
};

BingeReport.propTypes = {
  blocked: PropTypes.bool.isRequired,

  filters: PropTypes.shape({
    fields: FilterTypes.FilterSetType, // eslint-disable-line react/no-typos
    groupings: FilterTypes.GroupingSetType // eslint-disable-line react/no-typos
  }).isRequired,

  filtersActions: PropTypes.shape({
    getFiltersForPage: PropTypes.func.isRequired
  }).isRequired,

  queryActions: PropTypes.shape({
    runFormattedInlineQueriesForPage: PropTypes.func.isRequired
  }).isRequired,

  queries: PropTypes.shape({
    bingeReport: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      loading: PropTypes.bool.isRequired
    })
  }).isRequired
};

export default BingeReport;
